/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Decanter } from "./modelDecanter";

class ControllerDecanter extends ControllerModel {
    constructor() {
        super("ControllerDecanter");

        this.setNewNode = (callback) => {
            let decanter = new Decanter();
            decanter.decorate(callback);

            this.addNode(decanter);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let decanter = new Decanter();
            decanter.copyFrom(node);
            decanter.decorate(callback);
            this.addNode(decanter)
        }

        this.getProperties = async (node) => {
            let n = new Decanter();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Decanter();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerDecanter };